/* eslint-disable @typescript-eslint/no-explicit-any */
import TextCard from '~/components/Cards/TextCard/TextCard'
import EventCard from '~/components/Cards/NewsEvents/EventCard/EventCard'
import StatisticCard from '~/components/Cards/StatisticCard/StatisticCard'
import IconCard from '~/components/Cards/IconCard/IconCard'
import QuoteCard from '~/components/Cards/QuoteCard/QuoteCard'
import LinkCard from '~/components/Cards/LinkCard/LinkCard'
import ImageCard from '~/components/Cards/ImageCard/ImageCard'
import SingleContactCard from '~/components/Cards/ContactCard/Single/SingleContactCard'
import MultiContactCard from '~/components/Cards/ContactCard/Multi/MultiContactCard'
import CourseCard from '~/components/Cards/Study/CourseCard/CourseCard'
import ProfileCard from '../Cards/ProfileCard/ProfileCard'
import NewsCard from '../Cards/NewsEvents/NewsCard/NewsCard'

const componentMap = {
  cardText: TextCard,
  cardEvent: EventCard,
  cardStatistic: StatisticCard,
  cardIcon: IconCard,
  cardQuote: QuoteCard,
  cardLink: LinkCard,
  cardImage: ImageCard,
  cardContactSingle: SingleContactCard,
  cardContactMulti: MultiContactCard,
  cardStudyCourse: CourseCard,
  cardProfile: ProfileCard,
  pageNewsArticle: NewsCard,
  pageCaseStudyResearch: NewsCard
} as any

const loadComponent = (cmsComponentName: string) => {
  return componentMap[cmsComponentName]
}

export function Cards(props: any) {
  // console.log(props)
  const Component = loadComponent(props.content.sys?.contentTypeId)

  return <Component content={props.content} carousel={props.carousel} />
}
